export const SHOW_SELECTED_JOB = 'SHOW_SELECTED_JOB'

export function showSelectedJob(id){
  return {type:SHOW_SELECTED_JOB, payload:id}
}


// WEBPACK FOOTER //
// ./app/actions/TimeLineActions.js